// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__34Zof","tabItem":"Tab_tabItem__1TgbW","active":"Tab_active__g_sWE"};